'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.progressFilterPropertyToggleWidget = function (progressModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			onDataUpdated = function (newData, newFilter) {
				let checked = false;
				if (newFilter && newFilter[element.val()]) {
					checked = true;
				}
				element.prop('checked', checked);
			};
		element.on('click', function () {
			progressModel.toggleFilterProperty(element.val());
		});
		progressModel.addEventListener('progressContext', function (context) {
			if (context.isActive) {
				progressModel.addEventListener('dataUpdated', onDataUpdated);
			} else {
				progressModel.removeEventListener('dataUpdated', onDataUpdated);
			}
		});
	});

};
